module.exports = ".owl-carousel .owl-item img {\r\n     width: auto; \r\n}\r\n.searchThumb img {\r\n    height: 150px;\r\n    margin: 0 auto;\r\n}\r\n.searchThumbCaption {\r\n    text-align: center;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/search-images-list/search-images-list.component.css
// module id = ./src/app/components/ui/search-images-list/search-images-list.component.css
// module chunks = main